import {
  CONFIG_QRCODE_APP_URL_BY_ENVIRONMENT,
  useConfigState,
} from "@package/ui-config";
import { PostQrCodeSize, type Post } from "@package/ui-gql/index-data-access";
import { useMemo } from "react";
import { QRCode } from "react-qr-code";
import { QR_CODE_ENUM_TO_SIZE } from "../../constants/constants";
import { getQrCodeLinkUi, hasQrCodeLink } from "./post-qrcode-utils";

type PostQrCodeProps = {
  location: string;
  profile: string;
  post?: Post;
  size?: number;
  fgColor?: string;
  bgColor?: string;
};

export function PostQrCode({
  location,
  profile,
  post,
  size,
  fgColor,
  bgColor,
}: PostQrCodeProps) {
  const { environment } = useConfigState();

  const qrCodeLinkUi = useMemo(
    () =>
      getQrCodeLinkUi(
        CONFIG_QRCODE_APP_URL_BY_ENVIRONMENT[environment],
        post,
        location,
        profile,
      ),
    [environment, location, profile, post],
  );

  if (!hasQrCodeLink(location, profile, post) || !qrCodeLinkUi) {
    return null;
  }

  return (
    <QRCode
      size={
        size ??
        post?.qrCodeStyle?.qrSize ??
        QR_CODE_ENUM_TO_SIZE[
          post?.qrCodeLocation?.size ?? PostQrCodeSize.Medium
        ]
      }
      fgColor={fgColor}
      bgColor={bgColor}
      value={qrCodeLinkUi}
    />
  );
}
